import { render, staticRenderFns } from "./Advance-list-view.vue?vue&type=template&id=707a60e8&scoped=true"
import script from "./Advance-list-view.vue?vue&type=script&lang=js"
export * from "./Advance-list-view.vue?vue&type=script&lang=js"
import style0 from "./Advance-list-view.vue?vue&type=style&index=0&id=707a60e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a60e8",
  null
  
)

export default component.exports